<div class="cipx-form-container w-full">
  <cipx-scrollable-content [removeOverflowOnMobile]="true" [noPadding]="true" class="px-2">
    <!--Bond Details-->
    <div class="space-y-0">
      <div class="flex flex-col">
        <div class="flex flex-row justify-between items-center">
          <span class="bond-details-group-title">Bond Overview</span>
        </div>
        <div class="bond-details-group-content">
          <div class="bond-details-bond-label">
            {{ currentOpenQR?.quote_request_bond.bond_amount | currency: 'USD' }}
            {{ currentOpenQR?.quote_request_bond.state_abbreviation }}
            {{ currentOpenQR?.quote_request_bond.surety_bond_label }}
          </div>
          <div class="bond-details-grid">
            <!-- Order Number -->
            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-gray-200">Order #</p>
              <p class="text-md font-semibold text-gray-500">{{ currentOpenQR?.order_number }}</p>
            </div>

            @if (currentOpenQR?.selected_quote?.carrier_reference_number) {
              <div>
                <p class="text-sm font-medium text-gray-400 dark:text-gray-200">Bond #</p>
                <p class="text-md font-semibold text-gray-500">
                  {{ currentOpenQR?.selected_quote?.carrier_reference_number }}
                </p>
              </div>
            }

            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-gray-200">Effective Date</p>
              <p class="text-md font-semibold text-gray-500">
                {{ currentOpenQR?.selected_quote?.bond_effective_date | date: 'shortDate' }}
              </p>
            </div>

            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-gray-200">Term</p>

              @if (currentOpenQR?.selected_quote) {
                <p class="text-md font-semibold text-gray-500">
                  {{ currentOpenQR?.selected_quote?.duration + ' ' + currentOpenQR?.selected_quote?.duration_units }}
                </p>
              }
            </div>

            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-gray-200">Premium</p>
              @if (currentOpenQR?.total_cost) {
                <p class="text-md font-semibold text-gray-500">{{ currentOpenQR?.total_cost | currency: 'USD' }}</p>
              }
            </div>

            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-gray-200">Principal</p>
              <p class="text-md font-semibold text-gray-500">
                {{ currentOpenQR?.quote_request_bond?.company_name }}
                @if (currentOpenQR?.quote_request_bond?.company_dba) {
                  <br />
                  <span class="text-xs">{{ currentOpenQR?.quote_request_bond?.company_dba }}</span>
                }
              </p>
            </div>

            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-gray-200">Principal Address</p>
              <p class="text-md font-semibold text-gray-500">
                {{ getFormattedAddress(currentOpenQR?.principal_address) }}
              </p>
            </div>

            @for (owner of currentOpenQR?.owners; track $index) {
              <div>
                <p class="text-sm font-medium text-gray-400 dark:text-gray-200">
                  Owner/Indemnitor {{ currentOpenQR?.owners.length > 1 ? '(' + ($index + 1) + ')' : '' }}
                </p>
                <p class="text-md font-semibold text-gray-500">
                  {{ owner.name }}
                </p>
              </div>
              <div>
                <p class="text-sm font-medium text-gray-400 dark:text-gray-200">
                  Owner/Indemnitor Address {{ currentOpenQR?.owners.length > 1 ? '(' + ($index + 1) + ')' : '' }}
                </p>
                <p class="text-md font-semibold text-gray-500">{{ getFormattedAddress(owner?.address) }}</p>
              </div>
            }
          </div>
        </div>
      </div>
      <mat-divider class="my-2 bg-brandGreen"></mat-divider>
      <h2 class="bond-details-group-title text-xl">What do you need to change?</h2>
      <form [formGroup]="riderRequestForm" (ngSubmit)="submitForm()">
        <div>
          <mat-checkbox [color]="'primary'" formControlName="nameOnBond">Name on the bond</mat-checkbox>
          <div class="ml-2" *ngIf="riderRequestForm.get('nameOnBond')?.value">
            <mat-form-field class="w-full">
              <mat-label>Name as you'd like it written on the bond</mat-label>
              <input matInput type="text" formControlName="name_change" />
              <mat-error
                *ngIf="
                (riderRequestForm.get('name_change')?.invalid && riderRequestForm.get('name_change')?.touched) ||
                riderRequestForm.get('name_change').hasError('required')
              ">
                Please enter a valid name.
              </mat-error>
            </mat-form-field>
            <p class="text-md text-gray-500">
              If applicable, please be sure to include any DBA and verify that you have included any "Inc." or "LLC" at
              the end of your business name.
            </p>
          </div>
        </div>

        <!-- Address on Bond -->
        <div>
          <mat-checkbox [color]="'primary'" formControlName="addressOnBond">An address for the bond</mat-checkbox>
          <div class="ml-2" *ngIf="riderRequestForm.get('addressOnBond')?.value">
            <div class="mt-1">
              <mat-label class="font-semibold my-2">New Address</mat-label>
              <textarea
                rows="4"
                cdkTextareaAutosize="true"
                formControlName="address"
                class="w-full mt-4 border-2 rounded-lg p-2"
                [spellcheck]="true"></textarea>
            </div>

            <div class="mt-4">
              <mat-label class="font-semibold my-2">What is changing?</mat-label>
              <textarea
                rows="4"
                cdkTextareaAutosize="true"
                formControlName="change_type"
                class="w-full mt-4 border-2 rounded-lg p-2"
                [spellcheck]="true"></textarea>

              <p class="text-md text-gray-500">
                Company address change? Additional business location? New shipping or billing address? Which (if any)
                existing addresses are no longer valid?
              </p>
            </div>
          </div>
        </div>

        <!-- Effective Date -->
        <div>
          <mat-checkbox [color]="'primary'" formControlName="effectiveDateOnBond">Effective Date of Bond</mat-checkbox>
          <div class="ml-2" *ngIf="riderRequestForm.get('effectiveDateOnBond')?.value">
            <mat-form-field class="w-full">
              <mat-label>New Effective Date</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="effective_date" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error
                *ngIf="
                riderRequestForm.get('effective_date')?.invalid && riderRequestForm.get('effective_date')?.touched
              ">
                Please enter a valid date.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Expiration Date -->
        <div>
          <mat-checkbox [color]="'primary'" formControlName="expirationDateOnBond">Expiration Date of Bond
          </mat-checkbox>
          <div class="ml-2" *ngIf="riderRequestForm.get('expirationDateOnBond')?.value">
            <mat-form-field class="w-full">
              <mat-label>New Expiration Date</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="expiration_date" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error
                *ngIf="
                riderRequestForm.get('expiration_date')?.invalid && riderRequestForm.get('expiration_date')?.touched
              ">
                Please enter a valid date.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Bond Amount -->
        <div>
          <mat-checkbox [color]="'primary'" formControlName="bondAmountOnBond">Bond Amount</mat-checkbox>
          <div class="ml-2" *ngIf="riderRequestForm.get('bondAmountOnBond')?.value">
            <mat-form-field class="w-full">
              <mat-label>New Bond Amount</mat-label>
              <span matPrefix>$</span>
              <input type="number" class="pl-2" step="0.01" matInput formControlName="amount" />
              <mat-error *ngIf="riderRequestForm.get('amount')?.invalid && riderRequestForm.get('amount')?.touched">
                Please enter a valid amount.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Other Changes -->
        <div class="mb-4">
          <mat-checkbox [color]="'primary'" formControlName="otherChangesOnBond">Other Changes</mat-checkbox>
          <div *ngIf="riderRequestForm.get('otherChangesOnBond')?.value">
          <textarea
            rows="4"
            cdkTextareaAutosize="true"
            formControlName="otherChanges"
            class="w-full mt-4 border-2 rounded-lg p-2"
            [spellcheck]="true"></textarea>
          </div>
        </div>

        <!-- Additional Comments -->
        <div class="mb-4">
          <mat-label class="my-2">Additional Comments regarding the change</mat-label>
          <textarea
            rows="4"
            cdkTextareaAutosize="true"
            formControlName="customer_notes"
            class="w-full mt-4 border-2 rounded-lg p-2"
            [spellcheck]="true"></textarea>
        </div>
      </form>
    </div>

    <cipx-action-bar [sticky]="true" [removeStickyOnMobile]="false" justify="start" [layout]="'primary-first'">
      <div class="flex items-center gap-2">
        <cipx-primary-button [disabled]="false" [icon]="'heroicons_outline:chevron-right'" (buttonClick)="submitForm()">
          {{ 'Request Bond Change Rider' }}
        </cipx-primary-button>
        <cipx-cancel-button (buttonClick)="onCancelEvent()">Cancel</cipx-cancel-button>
      </div>
    </cipx-action-bar>
  </cipx-scrollable-content>
</div>
